import toast from "react-hot-toast";
import axiosInstance from "../helpers/axios";
import { authConstants } from "./constants";

export const adminLogin = (admin) => {
  return async (dispatch) => {
    const tid = toast.loading("Logging in...");
    dispatch({ type: authConstants.ADMIN_LOGIN_REQUEST });
    try {
      const res = await axiosInstance.post("/auth/admin/login", { ...admin });

      if (res.status === 200) {
        const { admin, token } = res.data;
        localStorage.setItem("adminToken", token);
        localStorage.setItem("admin", JSON.stringify(admin));
        dispatch({
          type: authConstants.ADMIN_LOGIN_SUCCESS,
          payload: { admin, token },
        });
        toast.success("Login successful", { id: tid });
      }
    } catch (error) {
      dispatch({
        type: authConstants.ADMIN_LOGIN_FAILURE,
        payload: { error: "Login failed" },
      });
      toast.error(`${error?.response?.data?.msg || "Login failed"}`, {
        id: tid,
      });
    }
  };
};

export const isAdminLoggedIn = () => {
  return async (dispatch) => {
    const token = localStorage.getItem("adminToken");

    if (token) {
      const admin = JSON.parse(localStorage.getItem("admin"));
      dispatch({
        type: authConstants.ADMIN_LOGIN_SUCCESS,
        payload: {
          token,
          admin,
        },
      });
    } else {
      dispatch({
        type: authConstants.ADMIN_LOGIN_FAILURE,
        payload: { error: "Failed to login!" },
      });
    }
  };
};

export const adminLogout = () => {
  return async (dispatch) => {
    const tid = toast.loading("Logging out...");
    dispatch({ type: authConstants.ADMIN_LOGOUT_REQUEST });
    try {
      await axiosInstance.get("/auth/admin/logout");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("admin");
      dispatch({ type: authConstants.ADMIN_LOGOUT_SUCCESS });
      toast.success("Logout successful", { id: tid });
    } catch (error) {
      dispatch({
        type: authConstants.ADMIN_LOGOUT_FAILURE,
        payload: { error: "Logout failed" },
      });
      toast.error("Logout failed", { id: tid });
    }
  };
};

export const getAdminByToken = () => {
  return async (dispatch) => {
    dispatch({ type: authConstants.GET_ADMIN_REQUEST });
    try {
      const res = await axiosInstance.get("/admin/services/get-admin");
      const { admin } = res.data;
      localStorage.removeItem("admin");
      localStorage.setItem("admin", JSON.stringify(admin));
      dispatch({
        type: authConstants.GET_ADMIN_SUCCESS,
        payload: { admin },
      });
    } catch (error) {
      dispatch({
        type: authConstants.GET_ADMIN_FAILURE,
        payload: { error: "Failed to fetch admin data" },
      });
    }
  };
};
